import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const opts = {
  iconfont: "mdi",
  breakpoint: {
    mobileBreakpoint: 960 // This is equivalent to a value of 960
  }
};

export default new Vuetify(opts);
